module.exports = __webpack_public_path__ + "img/base_hiver_chien_traineau.ea828516.svg";